import React, { PropsWithChildren, useCallback } from 'react'
import { AnonymousProvider, ApiKeyProvider, OidcProvider } from '@aserto/console-common'

import { useTopazLogin } from '../../api/login'
import { RpcStatus } from '../../types/local/tenant'
import { useConfig } from '../ConfigProvider'

const AuthProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const { authenticationType, oidcClientId, oidcDomain } = useConfig()
  const { mutateAsync: login } = useTopazLogin()
  const loginFunc = useCallback(
    async (apiKey: string): Promise<RpcStatus | Error | undefined> => {
      try {
        await login({ apiKey: apiKey })
        return
      } catch (error) {
        return new Promise((resolve) => {
          resolve(error as RpcStatus)
        })
      }
    },
    [login]
  )

  // self-hosted
  if (authenticationType?.toLowerCase() === 'oidc') {
    return (
      <OidcProvider oidcClientId={oidcClientId} oidcDomain={oidcDomain}>
        {children}
      </OidcProvider>
    )
  }
  if (authenticationType?.toLowerCase() === 'apikey') {
    return <ApiKeyProvider loginFunc={loginFunc}>{children}</ApiKeyProvider>
  }

  if (authenticationType?.toLowerCase() === 'anonymous') {
    return <AnonymousProvider>{children}</AnonymousProvider>
  }

  throw Error('Authentication type not supported, must be one of ["oidc", "apiKey", "anonymous"]')
}

export default AuthProvider
